import React, { useEffect, useState } from "react";
import PageLayout from "../../components/layouts/PageLayout";
import ContentLayout from "../../components/layouts/ContentLayout";
import CustomNavbar from "../../components/common/CustomNavbar";
import { CustomInput } from "../../components";
import CustomListInput from "../../components/common/CustomListInput";
import CustomSuggestionInput from "../../components/common/CustomSuggestionInput";
import DateRangePicker from "../../components/common/DateRangePicker";

export default function DevExamples() {
  /* ===================== STATE ===================== */

  const [form, setForm] = useState({
    text: "",
    email: "",
    password: "",
    number: "",
    date: "",
    search: "",
    select: "",
    list: [] as string[],
    suggestion: "",
    startDate: "",
    endDate: "",
  });
  const [isLoading, setIsLoading] = useState(true);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement> | any
  ) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  /* ===================== RENDER ===================== */

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);
  return (
    <PageLayout
      customNavbar={
        <CustomNavbar>
          <div className="flex gap-3 items-center w-max">
            <div className="font-medium">Component Playground</div>
            <CustomInput
              name="search"
              value={form.search}
              onChange={handleChange}
              placeholder="Search..."
              isSearchButton
              handleSearch={() => alert("Search clicked")}
            />
          </div>
        </CustomNavbar>
      }>
      <ContentLayout isLoading={isLoading}>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* ===================== BASIC INPUTS ===================== */}
          <Section title="Basic Inputs">
            <CustomInput
              label="Text"
              name="text"
              value={form.text}
              onChange={handleChange}
              placeholder="Text input"
            />

            <CustomInput
              label="Email"
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              placeholder="Email address"
            />

            <CustomInput
              label="Password"
              type="password"
              name="password"
              value={form.password}
              onChange={handleChange}
              placeholder="Password"
            />

            <CustomInput
              label="Number"
              type="number"
              name="number"
              value={form.number}
              onChange={handleChange}
              placeholder="Number"
            />
          </Section>

          {/* ===================== DATE & SELECT ===================== */}
          <Section title="Date & Select">
            <CustomInput
              label="Date"
              type="date"
              name="date"
              value={form.date}
              onChange={handleChange}
            />

            <CustomInput
              label="Select"
              type="select"
              name="select"
              value={form.select}
              onChange={handleChange}
              options={["OPTION A", "OPTION B", "OPTION C"]}
            />
          </Section>

          {/* ===================== LIST INPUT ===================== */}
          <Section title="List Input">
            <CustomListInput
              label="Tags / Keywords"
              name="list"
              value={form.list}
              onChange={handleChange}
              placeholder="Press Enter to add"
            />
          </Section>

          {/* ===================== SUGGESTION INPUT ===================== */}
          <Section title="Suggestion Input">
            <CustomSuggestionInput
              label="Comma Separated Suggestions"
              name="suggestion"
              value={form.suggestion}
              onChange={handleChange}
              placeholder="Type & select..."
              options={["REACT", "NEXTJS", "SPRING BOOT", "NODEJS", "MYSQL"]}
            />
          </Section>

          {/* ===================== DATE RANGE ===================== */}
          <Section title="Date Range Picker">
            <DateRangePicker
              startDate={form.startDate}
              endDate={form.endDate}
              onStartChange={(date) =>
                setForm((p) => ({ ...p, startDate: date }))
              }
              onEndChange={(date) => setForm((p) => ({ ...p, endDate: date }))}
            />
          </Section>
        </div>

        {/* ===================== DEBUG ===================== */}
        <div className="mt-10 bg-gray-50 border rounded-lg p-4 text-sm">
          <pre>{JSON.stringify(form, null, 2)}</pre>
        </div>
      </ContentLayout>
    </PageLayout>
  );
}

/* ===================== SECTION WRAPPER- temp for demo ===================== */

function Section({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) {
  return (
    <div className="border rounded-xl p-5 flex flex-col gap-4 bg-white">
      <h3 className="font-semibold text-sm text-gray-700">{title}</h3>
      {children}
    </div>
  );
}
